<template>
	<div class="game_detail_wrapper">
		<div class="game_detail_container" v-lazy:background-image="require('@/assets/static/imgs/home/m/detail-top-bg.png')">
            <div class="game_video_wrapper">
                <div class="game_video">
                    <video 
                        v-if="currentGame.video !== null" 
                        ref="detailBannerVideo" 
                        :poster="gameDetailViewPoster" 
                        :autoplay="true" 
                        :loop="true" 
                        data-object-fit="true" 
                        controls 
                        muted 
                        playsinline 
                        webkit-playsinline>
                        <source :src="currentGame.video" type="video/mp4">
                        Sorry, your browser does not support embedded videos.
                    </video>
                    <img 
                        v-else 
                        v-lazy="currentGame.interface[0]" alt="" />
                </div>
            </div>
        </div>

        <div class="game_detail_main_container">
            <div class="game_detail_main">
                <div class="game_info">
                    <div class="game_icon">
                        <img :src="currentGame.icon" alt="" />
                    </div>

                    <div class="game_name">
                        <p>{{ currentGame.game_name_cn }}</p>
                        <p v-if="false">
                            <template v-for="(countryCode, index) in currentGame.country">
                                {{ index > 0 ? '/' : '' }}{{ $t('index.country.' + countryCode) }}
                            </template>
                        </p>
                    </div>
                </div>

                <div class="game_desc_box">
                    <div class="game_desc">
                        <div class="desc_sty">
                            <p>{{ $t('index.game_introduction') }}</p>
                            <span v-if="false">{{ $t('index.game_introduction_arr.' + currentGame.game_id) || '' }}</span>
                            <span>{{ currentGame.introduce }}</span>
                        </div>

                        <div class="desc_sty">
                            <p>{{ $t('index.how_to_play') }}</p>
                            <span v-if="false">{{ $t('index.how_to_play_arr.' + currentGame.game_id) }}</span>
                            <span>{{ currentGame.desc }}</span>
                        </div>

                        <div class="desc_sty" v-if="false">
                            <p>{{ $t('index.support_language') }}</p>
                            <span class="lang">
                                <template v-for="(languageCode, index) in currentGame.language">
                                    {{ index > 0 ? '/' : '' }}{{ $t('index.support_language_arr.' + languageCode) }}
                                </template>
                            </span>
                        </div>

                        <div class="warning_sty">
                            <p>{{ $t('index.warning_tips') }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="shot_wrapper">
                <div>{{ $t('index.game_screenshot_tips') }}</div>
                <div class="shot_list_scroll_container">
                    <img 
                        v-for="(item, index) in currentGame.interface" :key="'gss_' + index" 
                        class="shot_img" 
                        v-lazy="item" alt="" />
                </div>
            </div>
        </div>

        <GlobalDeploymentMobile />

        <FooterMenuMobile />
    </div>
</template>

<script>
import gameDetailViewPoster   from '@/../public/static/imgs/gameDetailViewPosterMobile01.png';
import { fetchAllGamesCached } from '@/api/gameDataLoader';
import GlobalDeploymentMobile from '@/components/mobile/GlobalDeployment.vue';
import FooterMenuMobile       from '@/components/mobile/FooterMenu.vue';
import { goToHome }           from '@/utils/routerUtils';
import {
	NAV_IS_PAGE_SCROLL
} from '@/type/mutation';

export default {
	name      : 'GameDetailMobile',
    components: {
		GlobalDeploymentMobile,
        FooterMenuMobile
	},
    data() {
		return {
            // currentGameId: this.$store.state.currentGameId,
            currentGameId: 0,
            currentKey   : '',
            currentGame  : {},
            allGames     : [],
            gameDetailViewPoster
        };
    },

    created() {
        // this.currentGameId = this.$route.params.game_id;
        // this.currentGameId = this.$route.query.game_id;
        // this.currentGameId = this.$store.state.currentGameId;
        // console.log('=== created__$route__params__game_id >>>', this.$route.params.game_id);
        // console.log('=== created__$route__params__key >>>', this.$route.params.key);
        
        this.currentGameId = parseInt(this.$route.params.game_id);
        this.currentKey    = this.$route.params.key;
        // console.log('=== created__currentGameId >>>', this.currentGameId);
        // console.log('=== created__currentKey >>>', this.currentKey);

        // 首次由列表页跳转过来
        if(this.currentGameId !== 0 && this.currentKey !== '')
        {
            // 验证签名
            let sign = this.$Common.makeSign(this, this.currentGameId);
            if(sign !== this.currentKey)
            {
                this.goHome();
            }
            else
            {
                // 加载数据并初始化
                this.loadAllGamesAndInit();
                localStorage.setItem('_gid', this.currentGameId);
                localStorage.setItem('_key', this.currentKey);
            }
        }
        else// 刷新页面
        {
            let _gid = localStorage.getItem('_gid');
            let _key = localStorage.getItem('_key');
        }
    },

    mounted() {
        // console.log('=== Mobile GameDetailView mounted <<<');

        window.scrollTo(0, 0);

        // 监听页面滚动
    	window.addEventListener('scroll', this.handleScroll);
    },

    methods: {
        // 加载 allGames（缓存优先，无则请求），并初始化当前游戏
        async loadAllGamesAndInit()
        {
            try {
                this.allGames = await fetchAllGamesCached();
                this.initializeCurrentGame();
            } catch (err) {
                console.error('=== Mobile__GameDetail__load failed >>>', err);
            }
        },

        // 监听页面滚动
		handleScroll()
		{
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	        if(scrollTop)// 如果滚动距离大于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, true);
	      	}
			else if(scrollTop === 0)// 如果滚动距离等于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, false);
	      	}
		},

        // 初始化当前游戏
        initializeCurrentGame()
        {
            if(this.allGames.length > 0 && Number(this.currentGameId) !== 0)
            {
                this.currentGame = this.getGameObj(this.currentGameId);
            }
        },

        // 获取单个游戏对象
        getGameObj(currentGameId)
        {
            let currentGame = this.allGames.filter(game => String(game.game_id) === String(currentGameId));
            // console.log(this.$refs.detailBannerVideo);
            this.$nextTick(() => {
                // Reload the video element to apply the new source
                if(this.$refs.detailBannerVideo && typeof this.$refs.detailBannerVideo.load === 'function')
                {
                    this.$refs.detailBannerVideo.load();
                }
                else
                {
                    console.warn('detailBannerVideo does not exist');
                }
            });
            return currentGame[0];
        },

        // 跳转至首页
        goHome()
		{
			goToHome(this.$router);
		}
    },

    watch: {
        '$route.params.game_id': async function(newGameId, oldGameId) {
            this.currentGameId = parseInt(newGameId);
            if(!this.allGames.length) {
                await this.loadAllGamesAndInit();
            } else {
                this.currentGame = this.getGameObj(this.currentGameId);
            }
        },
        /* '$route.params.key'(newKey, oldKey) {
            // Route parameter 'key' has changed
            this.currentKey = newKey;
            this.fetchGameDetails(this.currentGameId, newKey);
        } */
    },

    beforeDestroy() {
		// window.removeEventListener("scroll", this.handleScroll);
	}
}
</script>

<style lang="less" scoped>
.game_detail_wrapper{
	width:var(--com-base-container-wm);height:auto;
	padding-top:0;
    background:linear-gradient(135deg, rgba(210, 223, 244, 1), rgba(236, 243, 255, 1), rgba(225, 240, 255, 1), rgba(243, 240, 255, 1));
    .game_detail_container{
        position:relative;
        width:inherit;height:var(--com-base-top-container-h2);
        background-position:center top;
		background-repeat:no-repeat;
		background-size:750px 760px;
        .game_video_wrapper{
            position:absolute;right:0;bottom:50px;left:0;
            margin:auto;
            width:302px;height:568px;
            border:8px solid rgba(255, 255, 255, .1);border-radius:40px;
            .game_video{
                width:286px;height:552px;
                border:8px solid rgba(255, 255, 255, .3);border-radius:32px;
                /* box-shadow:0 4px 20px 0 rgba(0, 0, 0, .15); */
                video{
                    width:270px;height:536px;
                    border:6px solid rgba(255, 255, 255, .9);border-radius:24px;
                    object-fit:cover;
                }
                img{
                    width:100%;height:100%;border-radius:24px;
                    object-fit:cover;
                }
            }
        }
    }
    .game_detail_main_container{
        width:inherit;height:auto;
        display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
        .game_detail_main{
            width:inherit;height:auto;
            padding-top:65px;padding-bottom:65px;
            .game_info{
                width:var(--com-base-content-wm);height:auto;
                margin:0 auto;
                display:flex;justify-content:flex-start;align-items:center;
                .game_icon{
                    width:130px;height:130px;
                    border-radius:25px;
                    box-shadow:0 0 20px 0 #a1befc;
                    img{
                        width:inherit;height:inherit;
                        border-radius:inherit;
                    }
                }
                .game_name{
                    padding-left:30px;
                    p:nth-child(1){
                        font-size:var(--com-base-fz-48);color:var(--com-main-ft-color);font-weight:bold;
                    }
                    p:nth-child(2){
                        font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-22);color:#676D77;font-weight:normal;
                    }
                }
            }
            .game_desc_box{
                position:relative;
                width:var(--com-base-content-wm);height:auto;
                margin:0 auto;margin-top:60px;padding:40px 20px;
                border-radius:18px;border:2px solid #FFF;
                background:#F2F7FF;
                .game_desc{
                    width:100%;height:auto;
                    display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;
                    /* gap:50px; */
                    .desc_sty{
                        margin-bottom:20px;
                        p{
                            font-size:var(--com-base-fz-28);color:#5B77A1;font-weight:bold;
                        }
                        span{
                            font-size:var(--com-base-fz-24);color:#8798B1;font-weight:normal;
                            line-height:1.5;
                            display:block;
                            width:100%;height:auto;
                            margin-top:5px;padding:0;
                        }
                        span.lang{
                            font-family:var(--com-number-coin-fm-R);height:70px;
                        }
                    }
                    .warning_sty{
                        p{
                            font-size:var(--com-base-fz-24);color:#1D55FF;
                        }
                    }
                }
            }
        }
        .shot_wrapper{
            width:var(--com-base-content-wm);height:auto;
            padding-bottom:100px;
            div:nth-child(1){
                width:100%;height:90px;line-height:90px;
                font-size:var(--com-base-fz-58);color:var(--com-main-ft-color);font-weight:bold;text-align:center;
            }
            div.shot_list_scroll_container{
                margin-top:30px;
                display:flex;justify-content:space-between;align-items:flex-start;
                overflow-x:auto;
				overflow-y:hidden;
				white-space:nowrap;
				-ms-overflow-style:none;/* IE和Edge浏览器隐藏滚动条 */
  				scrollbar-width:none;   /* Firefox隐藏滚动条 */
                img{
                    margin-right:50px;
                    width:270px;height:536px;
                    border-radius:24px;border:5px solid #FFF;
                    box-shadow:0 4px 20px 0 rgba(0, 0, 0, .15);
                    object-fit:cover;
                }
            }
            div.shot_list_scroll_container::-webkit-scrollbar{
				display:none;/* Chrome、Safari和Edge隐藏滚动条 */
			}
        }
    }
}
</style>
